import { IAppState } from '../common/state';

export const getIsFavoritesFoldersEnabled = (state: IAppState) => state.featureToggle.isFavoritesFoldersEnabled;
